/* eslint-disable complexity */
/* istanbul ignore file */
// avoiding package root import to avoid circular dependency
// eslint-disable-next-line monorepo/no-internal-import
import {Locale} from '@aboutyou/config/src/locale';
// eslint-disable-next-line monorepo/no-internal-import
import {assertUnreachable} from '@aboutyou/utils/src/assertUnreachable';

export interface SpecialSlugs {
  cancellation: string;
  shippingAndDelivery: string;
  payment: string;
  contact: string;
}

export function getSpecialSlugsByLocale_UNSAFE(locale: Locale): SpecialSlugs {
  switch (locale) {
    case Locale.de_DE:
    case Locale.de_AT:
    case Locale.de_CH:
      return {
        cancellation: 'Widerruf',
        shippingAndDelivery: 'versand-und-lieferkosten',
        payment: 'zahlung',
        contact: 'kontakt',
      };

    case Locale.fr_CH:
    case Locale.fr_BE:
    case Locale.fr_LU:
    case Locale.fr_FR:
      return {
        cancellation: '',
        shippingAndDelivery: 'expedition-et-frais-de-port',
        payment: 'paiement',
        contact: 'contact',
      };

    case Locale.nl_NL:
    case Locale.nl_BE:
      return {
        cancellation: '',
        shippingAndDelivery: 'verzend-en-leverkosten',
        payment: 'betaling',
        contact: 'contact',
      };

    case Locale.pl_PL:
      return {
        cancellation: '',
        shippingAndDelivery: 'koszty-wysylki-i-dostawy',
        payment: 'platnosc',
        contact: 'kontakt',
      };

    case Locale.cs_CZ:
      return {
        cancellation: '',
        shippingAndDelivery: 'doprava-a-postovne',
        payment: 'platba',
        contact: 'kontakt',
      };

    case Locale.sk_SK:
      return {
        cancellation: '',
        shippingAndDelivery: 'dorucenie-a-postovne',
        payment: 'platba',
        contact: 'kontakt',
      };

    case Locale.ro_RO:
      return {
        cancellation: '',
        shippingAndDelivery: 'transport-si-costuri-livrare',
        payment: 'plata',
        contact: 'contact',
      };

    case Locale.hu_HU:
      return {
        cancellation: '',
        shippingAndDelivery: 'rendelesi-es-szallitasi-koltsegek',
        payment: 'fizetes',
        contact: 'kapcsolat',
      };

    case Locale.sl_SI:
      return {
        cancellation: 'odstop-od-pogodbe',
        shippingAndDelivery: 'stroski-posiljanja-in-dostave',
        payment: 'placilo',
        contact: 'kontakt',
      };

    case Locale.lv_LV:
      return {
        cancellation: 'atteikuma-tiesibas',
        shippingAndDelivery: 'piegade',
        payment: 'maksajums',
        contact: 'kontakti',
      };

    case Locale.lt_LT:
      return {
        cancellation: 'teise-atsisakyti-sutarties',
        shippingAndDelivery: 'pristatymas',
        payment: 'atsiskaitymas',
        contact: 'kontaktai',
      };

    case Locale.et_EE:
      return {
        cancellation: 'taganemisoigus',
        shippingAndDelivery: 'saate-ja-tarnekulud',
        payment: 'maksmine',
        contact: 'kontakt',
      };

    case Locale.hr_HR:
      return {
        cancellation: 'raskid-ugovora',
        shippingAndDelivery: 'troskovi-dostave',
        payment: 'placanje',
        contact: 'kontakt',
      };

    case Locale.bg_BG:
      return {
        cancellation: 'contract-withdrawal',
        shippingAndDelivery: 'tseni-za-dostavka',
        payment: 'plashtane',
        contact: 'contact',
      };

    case Locale.da_DK:
    case Locale.en_ZZ:
    case Locale.en_DE:
    case Locale.en_IE:
    case Locale.sv_SE:
    case Locale.fi_FI:
    case Locale.ar_SA:
    case Locale.en_SA:
    case Locale.he_IL:
    case Locale.en_IL:
      return {
        cancellation: 'contract-withdrawal',
        shippingAndDelivery: 'shipping-and-delivery-fees',
        payment: 'payment',
        contact: 'contact',
      };

    case Locale.es_ZZ:
    case Locale.es_ES:
      return {
        cancellation: 'derecho-a-retirada',
        shippingAndDelivery: 'gastos-de-envio-y-entrega',
        payment: 'pago',
        contact: 'contacto',
      };

    case Locale.it_IT:
    case Locale.it_CH:
      return {
        cancellation: 'diritto-di-recesso',
        shippingAndDelivery: 'spese-di-spedizione-e-consegna',
        payment: 'pagamento',
        contact: 'contatti',
      };

    case Locale.pt_PT:
      return {
        cancellation: 'rescisao-de-contrato',
        shippingAndDelivery: 'taxas-de-envio-e-entrega',
        payment: 'pagamento',
        contact: 'contacto',
      };
    case Locale.el_CY:
    case Locale.el_GR:
      return {
        cancellation: 'contract-withdrawal',
        shippingAndDelivery: 'shipping-and-delivery-costs',
        payment: 'payment',
        contact: 'contact',
      };

    case Locale.no_NO:
      return {
        cancellation: 'kontraktoppsigelse',
        shippingAndDelivery: 'frakt-og-leveringskostnader',
        payment: 'betaling',
        contact: 'kontakt',
      };

    case Locale.ru_EE:
    case Locale.ru_LV:
      return {
        cancellation: 'rastorzhenie-dogovora',
        shippingAndDelivery: 'stoimost-dostavki',
        payment: 'oplata',
        contact: 'kontakty',
      };

    default:
      assertUnreachable(locale);
  }
}
